var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('validation-input',{attrs:{"rules":_vm.rules,"label":_vm.label},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var uuid = ref.uuid;
return [_c('b-datepicker',_vm._g(_vm._b({attrs:{"id":uuid,"locale":"es-ES","placeholder":_vm.txt_placeholder},model:{value:(_vm.fecha),callback:function ($$v) {_vm.fecha=$$v},expression:"fecha"}},'b-datepicker',_vm.$attrs,false),_vm.$listeners))]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }